import { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import InlineMessage from '@atlaskit/inline-message';

import urls from 'src/urls/search';

import messages from './syntax-hint.i18n';
import * as styles from './syntax-hint.style';

export default injectIntl(
  class SyntaxHint extends PureComponent<{
    intl: InjectedIntl;
    syntaxError: 'OPERATOR' | 'EXTENSION' | null;
  }> {
    render() {
      const { intl, syntaxError } = this.props;

      return (
        <styles.ResultsSyntaxHint>
          {syntaxError === 'OPERATOR' && (
            <InlineMessage
              secondaryText={intl.formatMessage(
                messages.wrongOperatorHintSecondaryText
              )}
              appearance="info"
            >
              <FormattedMessage
                {...messages.syntaxHintMessage}
                values={{
                  learnMoreLink: (
                    <a href={urls.external.docs} target="_blank">
                      <FormattedMessage {...messages.syntaxLearnMoreLink} />
                    </a>
                  ),
                }}
              />
            </InlineMessage>
          )}
          {syntaxError === 'EXTENSION' && (
            <span>
              <FormattedMessage {...messages.wrongExtensionHintSecondaryText} />{' '}
              <a href={urls.external.docs} target="_blank">
                <FormattedMessage {...messages.syntaxLearnMoreLink} />
              </a>
            </span>
          )}
        </styles.ResultsSyntaxHint>
      );
    }
  }
);
